import React from 'react'

interface ContentContainerProps {
  children?: React.ReactNode;
  noPadding?: boolean;
}

const ContentContainer = ({ children, noPadding }: ContentContainerProps) => {
  return (
    <div className="new_appointment__container">
      {/* `noPadding && {...}` can be `false`; cast keeps original runtime value while satisfying the style prop type */}
      <div className="new_appointment__container_box" style={(noPadding && { paddingRight: 0, paddingLeft: 0 }) as React.CSSProperties}>
        {children}
      </div>
    </div>
  )
}

export default ContentContainer;
